import { render, staticRenderFns } from "./mendian.vue?vue&type=template&id=2d0a3c88&scoped=true"
import script from "./mendian.vue?vue&type=script&lang=js"
export * from "./mendian.vue?vue&type=script&lang=js"
import style0 from "./mendian.vue?vue&type=style&index=0&id=2d0a3c88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0a3c88",
  null
  
)

export default component.exports